import { createFileRoute } from "@tanstack/react-router";
import { PlatformSchedulerPage } from "@/components/platform-scheduler-page";
import { buildPageHead } from "@/lib/seo-meta";

const path = "/channels/x";

export const Route = createFileRoute(path)({
	component: XScheduler,
	head: ({ matches }) =>
		buildPageHead({
			matches,
			internalPath: path,
			title: "AgentReacher | Connect your AI agent to X",
			description:
				"Schedule X posts and threads with an AI agent. Draft, queue, and publish without losing your voice. Cancel anytime.",
		}),
});

function XScheduler() {
	return (
		<PlatformSchedulerPage
			platform="x"
			platformLabel="X (Twitter)"
			hero={{
				title: "Connect your AI agent to X",
				description:
					"Connect AgentReacher to your AI assistant via MCP. Ask it to draft posts, build threads, or schedule a week of X content. You review and approve.",
			}}
		/>
	);
}
